import React from 'react';
import parse from 'html-react-parser';
import { CTApath, formCTAurl, SigninRefPath } from '../../scripts/registration';
import { IReturnUserFullConfig } from './ReturnUserFull';
import {
  DisclosuresWrapper,
  DisclosureSymbol,
  DisclosureWithSymbol
} from '../disclosures/Disclosures';
import {
  marketplaceDisclosure,
  noDingCombinedDisclosure,
  noDingDisclosure
} from '../../documents/disclosures/cm-disclosures';
import {
  debitCardCFSB,
  insuranceResultsShort,
  preApprovedFico,
  savingsNegotiationAlerts,
  scoreBoostResults
} from '../../documents/disclosures/regulatory';

const GATSBY_CORVETTE_HOST = process.env.GATSBY_CORVETTE_HOST;

export const returnUserHmpConfig: IReturnUserFullConfig = {
  subHeadingCol1: 'Let’s check in on your credit and finances.',
  btnTextCol1: 'Sign in',
  btnLinkCol1: formCTAurl({}, CTApath.loginIndex),
  btnLink2Col1: formCTAurl({
    offer: 'at_frsas119',
    cname: 'FREE_102'
  }),
  headingCol2: 'You have credit cards matched to you',
  subHeadingCol2: (
    <>
      Look for cards labeled No Ding Decline™ which won’t hurt your credit scores if you are not
      approved.
      <DisclosureSymbol disclosure={noDingDisclosure} />
    </>
  ),
  btnTextCol2: 'See your cards',
  btnLinkCol2: `${GATSBY_CORVETTE_HOST}/myOffers/cards?plpqfilter=ndd`,
  mqeBottomSection: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <DisclosureWithSymbol disclosure={noDingDisclosure} />
    </DisclosuresWrapper>
  ),
  spotIconCards: [
    {
      icon: 'icon-piggy-bank.svg',
      alt: 'Icon piggy bank.',
      heading: (
        <>
          Manage bills & subscriptions
          <DisclosureSymbol disclosure={savingsNegotiationAlerts} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.finRecurringPayment }, CTApath.loginIndex),
      dataOp: 'QAN'
    },
    {
      icon: 'icon-boost-rocket.svg',
      alt: 'Icon boost rocket.',
      heading: (
        <>
          Boost your credit scores
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.boostOnboarding }, CTApath.loginIndex),
      dataOp: 'QAB'
    },
    {
      icon: 'icon-experian-smart-money.svg',
      alt: 'Icon experian smart money.',
      heading: (
        <>
          Build credit with a digital checking account
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.monCreateAccount }, CTApath.loginIndex),
      dataOp: 'QAS'
    },
    {
      icon: 'icon-web-security.svg',
      alt: 'Icon web security.',
      heading: 'Run a free identity scan',
      link: formCTAurl({ refUrl: SigninRefPath.protection }, CTApath.loginIndex),
      dataOp: 'QAI'
    },
    {
      icon: 'icon-wallet.svg',
      alt: 'Icon wallet.',
      heading: (
        <>
          See personal loan offers
          <DisclosureSymbol disclosure={marketplaceDisclosure} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.personalLoans }, CTApath.loginIndex),
      dataOp: 'QAP'
    },
    {
      icon: 'icon-car.svg',
      alt: 'Icon car.',
      heading: (
        <>
          Save on auto insurance
          <DisclosureSymbol disclosure={insuranceResultsShort} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.insuranceHub }, CTApath.loginIndex),
      dataOp: 'QAA'
    }
  ],
  bottomDisclosures: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <p>{parse(debitCardCFSB)}</p>
      <DisclosureWithSymbol disclosure={savingsNegotiationAlerts} />
      <DisclosureWithSymbol disclosure={scoreBoostResults} />
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
      <DisclosureWithSymbol disclosure={insuranceResultsShort} />
    </DisclosuresWrapper>
  )
};

export const returnUserNDDConfig: IReturnUserFullConfig = {
  subHeadingCol1: (
    <>
      Check for personal loan and credit card offers labeled No Ding Decline™. Applying for these
      labeled offers won’t hurt your credit scores if you aren’t initially approved.
      <DisclosureSymbol disclosure={noDingCombinedDisclosure} />
    </>
  ),
  btnTextCol1: 'Sign in',
  btnLinkCol1: formCTAurl({ refUrl: SigninRefPath.noDingCreditCards }, CTApath.loginIndex),
  btnLink2Col1: formCTAurl({
    offer: 'at_frsas119',
    cname: 'FREE_102',
    refUrl: SigninRefPath.noDingCreditCards
  }),
  headingCol2: (
    <>
      See your No Ding Decline™ offers that won’t ding your credit scores if you are not initially
      approved
      <DisclosureSymbol disclosure={noDingCombinedDisclosure} />
    </>
  ),
  btnTextCol2: 'See your cards',
  btnLinkCol2: `${GATSBY_CORVETTE_HOST}/myOffers/cards?plpqfilter=ndd`,
  mqeBottomSection: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <DisclosureWithSymbol disclosure={noDingCombinedDisclosure} />
    </DisclosuresWrapper>
  ),
  spotIconCards: [
    {
      icon: 'icon-experian-smart-money.svg',
      alt: 'Icon experian smart money.',
      heading: (
        <>
          Build credit with a digital checking account
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.monCreateAccount }, CTApath.loginIndex),
      dataOp: 'QAS'
    },
    {
      icon: 'icon-piggy-bank.svg',
      alt: 'Icon piggy bank.',
      heading: (
        <>
          Manage bills & subscriptions
          <DisclosureSymbol disclosure={savingsNegotiationAlerts} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.finRecurringPayment }, CTApath.loginIndex),
      dataOp: 'QAN'
    },
    {
      icon: 'icon-boost-rocket.svg',
      alt: 'Icon boost rocket.',
      heading: (
        <>
          Boost your credit scores
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.boostOnboarding }, CTApath.loginIndex),
      dataOp: 'QAB'
    },
    {
      icon: 'icon-credit-card.svg',
      alt: 'Icon credit card.',
      heading: (
        <>
          Find the right credit card
          <DisclosureSymbol disclosure={marketplaceDisclosure} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.creditCards }, CTApath.loginIndex),
      dataOp: 'QAC'
    },
    {
      icon: 'icon-web-security.svg',
      alt: 'Icon web security.',
      heading: 'Run a free identity scan',
      link: formCTAurl({ refUrl: SigninRefPath.protection }, CTApath.loginIndex),
      dataOp: 'QAI'
    },
    {
      icon: 'icon-car.svg',
      alt: 'Icon car.',
      heading: (
        <>
          Save on auto insurance
          <DisclosureSymbol disclosure={insuranceResultsShort} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.insuranceHub }, CTApath.loginIndex),
      dataOp: 'QAA'
    }
  ],
  bottomDisclosures: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <p>{parse(debitCardCFSB)}</p>
      <DisclosureWithSymbol disclosure={scoreBoostResults} />
      <DisclosureWithSymbol disclosure={savingsNegotiationAlerts} />
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
      <DisclosureWithSymbol disclosure={insuranceResultsShort} />
    </DisclosuresWrapper>
  )
};
export const returnUserCreditScoreConfig: IReturnUserFullConfig = {
  subHeadingCol1: 'Let’s check in on your credit and finances.',
  btnTextCol1: 'Sign in',
  btnLinkCol1: formCTAurl({}, CTApath.loginIndex),
  btnLink2Col1: formCTAurl({
    offer: 'at_frsas119',
    cname: 'FREE_102'
  }),
  headingCol2: 'You have credit cards matched to you',
  subHeadingCol2: (
    <>
      Most Experian members who visit our marketplace will see pre-approved credit card offers.
      <DisclosureSymbol disclosure={preApprovedFico} />
    </>
  ),
  btnTextCol2: 'See your cards',
  btnLinkCol2: `${GATSBY_CORVETTE_HOST}/myOffers/cards`,
  mqeBottomSection: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <DisclosureWithSymbol disclosure={preApprovedFico} />
    </DisclosuresWrapper>
  ),
  spotIconCards: [
    {
      icon: 'icon-new-credit.svg',
      alt: 'Icon new credit.',
      heading: 'View your free credit report',
      link: formCTAurl({ refUrl: SigninRefPath.creditReport }, CTApath.loginIndex),
      dataOp: 'QAR'
    },
    {
      icon: 'icon-piggy-bank.svg',
      alt: 'Icon piggy bank.',
      heading: (
        <>
          Manage bills & subscriptions
          <DisclosureSymbol disclosure={savingsNegotiationAlerts} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.finRecurringPayment }, CTApath.loginIndex),
      dataOp: 'QAN'
    },
    {
      icon: 'icon-boost-rocket.svg',
      alt: 'Icon boost rocket.',
      heading: (
        <>
          Boost your credit scores
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.boostOnboarding }, CTApath.loginIndex),
      dataOp: 'QAB'
    },
    {
      icon: 'icon-wallet.svg',
      alt: 'Icon wallet.',
      heading: (
        <>
          See personal loan offers
          <DisclosureSymbol disclosure={marketplaceDisclosure} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.personalLoans }, CTApath.loginIndex),
      dataOp: 'QAP'
    },
    {
      icon: 'icon-experian-smart-money.svg',
      alt: 'Icon experian smart money.',
      heading: (
        <>
          Build credit with a digital checking account
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.monCreateAccount }, CTApath.loginIndex),
      dataOp: 'QAS'
    },
    {
      icon: 'icon-car.svg',
      alt: 'Icon car.',
      heading: (
        <>
          Save on auto insurance
          <DisclosureSymbol disclosure={insuranceResultsShort} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.insuranceHub }, CTApath.loginIndex),
      dataOp: 'QAA'
    }
  ],
  bottomDisclosures: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <p>{parse(debitCardCFSB)}</p>
      <DisclosureWithSymbol disclosure={savingsNegotiationAlerts} />
      <DisclosureWithSymbol disclosure={scoreBoostResults} />
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
      <DisclosureWithSymbol disclosure={insuranceResultsShort} />
    </DisclosuresWrapper>
  )
};
export const returnUserPLConfig: IReturnUserFullConfig = {
  subHeadingCol1: 'Looking to pay off debt or get cash fast? Get your loan offers in minutes.',
  btnTextCol1: 'Sign in',
  btnLinkCol1: formCTAurl({ refUrl: SigninRefPath.loansPrequal, skip: 'int' }, CTApath.loginIndex),
  btnLink2Col1: formCTAurl({
    offer: 'at_frsas119',
    cname: 'FREE_102',
    refUrl: SigninRefPath.personalLoans
  }),
  headingCol2: (
    <>
      See loan offers matched to you instantly
      <DisclosureSymbol disclosure={marketplaceDisclosure} />
    </>
  ),
  btnTextCol2: 'See your loan options',
  btnLinkCol2: formCTAurl(
    {
      refUrl: SigninRefPath.personalLoans
    },
    CTApath.loginIndex
  ),
  mqeBottomSection: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
    </DisclosuresWrapper>
  ),
  spotIconCards: [
    {
      icon: 'icon-experian-smart-money.svg',
      alt: 'Icon experian smart money.',
      heading: (
        <>
          Build credit with a digital checking account
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.monCreateAccount }, CTApath.loginIndex),
      dataOp: 'QAS'
    },
    {
      icon: 'icon-piggy-bank.svg',
      alt: 'Icon piggy bank.',
      heading: (
        <>
          Manage bills & subscriptions
          <DisclosureSymbol disclosure={savingsNegotiationAlerts} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.finRecurringPayment }, CTApath.loginIndex),
      dataOp: 'QAN'
    },
    {
      icon: 'icon-boost-rocket.svg',
      alt: 'Icon boost rocket.',
      heading: (
        <>
          Boost your credit scores
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.boostOnboarding }, CTApath.loginIndex),
      dataOp: 'QAB'
    },

    {
      icon: 'icon-credit-card.svg',
      alt: 'Icon credit card.',
      heading: 'Find the right credit card',
      link: `${GATSBY_CORVETTE_HOST}/myOffers/cards`,
      dataOp: 'QAC'
    },
    {
      icon: 'icon-web-security.svg',
      alt: 'Icon web security.',
      heading: 'Run a free identity scan',
      link: formCTAurl({ refUrl: SigninRefPath.protection }, CTApath.loginIndex),
      dataOp: 'QAI'
    },
    {
      icon: 'icon-car.svg',
      alt: 'Icon car.',
      heading: (
        <>
          Save on auto insurance
          <DisclosureSymbol disclosure={insuranceResultsShort} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.insuranceHub }, CTApath.loginIndex),
      dataOp: 'QAA'
    }
  ],
  bottomDisclosures: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <p>{parse(debitCardCFSB)}</p>
      <DisclosureWithSymbol disclosure={savingsNegotiationAlerts} />
      <DisclosureWithSymbol disclosure={scoreBoostResults} />
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
      <DisclosureWithSymbol disclosure={insuranceResultsShort} />
    </DisclosuresWrapper>
  )
};
export const returnUserCCConfig: IReturnUserFullConfig = {
  subHeadingCol1: (
    <>
      Most Experian members who visit our marketplace will see pre-approved credit card offers.
      <DisclosureSymbol disclosure={preApprovedFico} />
    </>
  ),
  btnTextCol1: 'Sign in',
  btnLinkCol1: formCTAurl({ refUrl: SigninRefPath.noDingCreditCards }, CTApath.loginIndex),
  btnLink2Col1: formCTAurl({
    offer: 'at_frsas119',
    cname: 'FREE_102',
    refUrl: SigninRefPath.noDingCreditCards
  }),
  headingCol2: (
    <>
      You have personalized credit card offers matched to you
      <DisclosureSymbol disclosure={preApprovedFico} />
    </>
  ),
  btnTextCol2: 'See your cards',
  btnLinkCol2: `${GATSBY_CORVETTE_HOST}/myOffers/cards?plpqfilter=ndd`,
  mqeBottomSection: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <DisclosureWithSymbol disclosure={preApprovedFico} />
    </DisclosuresWrapper>
  ),
  spotIconCards: [
    {
      icon: 'icon-experian-smart-money.svg',
      alt: 'Icon experian smart money.',
      heading: (
        <>
          Build credit with a digital checking account
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.monCreateAccount }, CTApath.loginIndex),
      dataOp: 'QAS'
    },
    {
      icon: 'icon-piggy-bank.svg',
      alt: 'Icon piggy bank.',
      heading: (
        <>
          Manage bills & subscriptions
          <DisclosureSymbol disclosure={savingsNegotiationAlerts} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.finRecurringPayment }, CTApath.loginIndex),
      dataOp: 'QAN'
    },
    {
      icon: 'icon-boost-rocket.svg',
      alt: 'Icon boost rocket.',
      heading: (
        <>
          Boost your credit scores
          <DisclosureSymbol disclosure={scoreBoostResults} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.boostOnboarding }, CTApath.loginIndex),
      dataOp: 'QAB'
    },
    {
      icon: 'icon-wallet.svg',
      alt: 'Icon wallet.',
      heading: (
        <>
          See personal loan offers
          <DisclosureSymbol disclosure={marketplaceDisclosure} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.personalLoans }, CTApath.loginIndex),
      dataOp: 'QAP'
    },
    {
      icon: 'icon-web-security.svg',
      alt: 'Icon web security.',
      heading: 'Run a free identity scan',
      link: formCTAurl({ refUrl: SigninRefPath.protection }, CTApath.loginIndex),
      dataOp: 'QAI'
    },
    {
      icon: 'icon-car.svg',
      alt: 'Icon car.',
      heading: (
        <>
          Save on auto insurance
          <DisclosureSymbol disclosure={insuranceResultsShort} />
        </>
      ),
      link: formCTAurl({ refUrl: SigninRefPath.insuranceHub }, CTApath.loginIndex),
      dataOp: 'QAA'
    }
  ],
  bottomDisclosures: (
    <DisclosuresWrapper className="disclosures disclosures-mt">
      <p>{parse(debitCardCFSB)}</p>
      <DisclosureWithSymbol disclosure={savingsNegotiationAlerts} />
      <DisclosureWithSymbol disclosure={scoreBoostResults} />
      <DisclosureWithSymbol disclosure={marketplaceDisclosure} />
      <DisclosureWithSymbol disclosure={insuranceResultsShort} />
    </DisclosuresWrapper>
  )
};
